import { render, staticRenderFns } from "./repair-detail.vue?vue&type=template&id=4d9c7530&scoped=true"
import script from "./repair-detail.vue?vue&type=script&lang=js"
export * from "./repair-detail.vue?vue&type=script&lang=js"
import style0 from "./repair-detail.vue?vue&type=style&index=0&id=4d9c7530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9c7530",
  null
  
)

export default component.exports